// Manuscript Import
export const CLEAR_IMPORT_DATA = 'clearImportData';
export const SET_QUEUE_SEARCH_TEXT = 'setQueueSearchText';
export const SET_QUEUE_SORT = 'setQueueSort';
export const SET_GUID_IMPORT_TEXT = 'setGuidImportText';
export const REMOVE_IMPORT_ITEM = 'removeImportItem';
export const ADD_IMPORT_ITEMS = 'addImportItems';
export const UPDATE_IMPORT_ITEMS = 'updateImportItems';
export const UPDATE_AND_VALIDATE_IMPORT_ITEMS = 'updateAndValidateImportItems';
export const ADD_GUID_IMPORT_ITEMS = 'addGuidImportItems';
export const ADD_FILE_IMPORT_ITEMS = 'addFileImportItems';
export const ADD_IMPORT_ITEMS_TO_QUEUE = 'addImportItemsToQueue';
export const VALIDATE_IMPORT_ITEMS = 'validateImportItems';
export const GET_QUEUE_ITEMS = 'getQueueItems';
export const UPDATE_FLEX_BOXES = 'updateFlexBoxes';
export const START_QUEUE_ITEM_UPDATES = 'startQueueItemUpdates';
export const STOP_QUEUE_ITEM_UPDATES = 'stopQueueItemUpdates';
export const SET_QUEUE_ITEM_UPDATES_ENABLED = 'setQueueItemUpdatesEnabled';
export const SET_CONFIRM_NAVIGATE_DIALOG = 'setConfirmNavigateDialog';

// Manuscript Builder
export const SET_CONFIRM_DELETE_MANUSCRIPT_DIALOG = 'setConfirmDeleteManuscriptDialog';
export const SET_CONFIRM_TAB_NAVIGATION_DIALOG = 'setConfirmTabNavigationDialog';
export const SET_METADATA_HAS_UNSAVED_CHANGES = 'setMetadataHasUnsavedChanges';

// Manuscript Generate
export const GENERATE_STATUS_NOT_GENERATED = 'not-generated';
export const GENERATE_STATUS_GENERATING = 'generating';
export const GENERATE_STATUS_GENERATED = 'generated';
export const GENERATE_STATUS_REGENERATE_NEEDED = 'regenerate-needed';
export const GENERATE_STATUS_DISABLED = 'disabled';
export const GENERATE_STATUS_ERROR = 'error';
export const GENERATE_STATUS_MODIFIED = 'modified';

// Manuscript Export
export const TOGGLE_ALL_EXPORTS = 'toggleAllExports';
export const TOGGLE_EXPORT_ITEM = 'toggleExportItem';
export const DOWNLOAD_SELECTED_EXPORTS = 'downloadSelectedExports';
export const CLEAR_SELECTED_EXPORTS = 'clearSelectedExports';
export const MAX_SELECTED_EXPORTS = 50;

// Import Errors
export const ERROR_INVALID_GUID = 'ErrorInvalidGuid';
export const ERROR_INVALID_POINTER_GUID = 'ErrorInvalidPointerGuid';
export const ERROR_VALIDATION_FAILED = 'ErrorValidationFailed';
export const ERROR_INVALID_FILENAME = 'ErrorInvalidFilename';
export const ERROR_INVALID_FILE_EXTENSION = 'ErrorInvalidFileExtension';
export const ERROR_FAILED_TO_IMPORT = 'ErrorFailedToImport';

export const PREVENT_IMPORT_ERRORS = [
  ERROR_INVALID_GUID,
  ERROR_INVALID_POINTER_GUID,
  ERROR_VALIDATION_FAILED,
  ERROR_INVALID_FILENAME,
  ERROR_INVALID_FILE_EXTENSION,
];

export const GUID_IMPORT_ERRORS = [
  ERROR_INVALID_GUID,
  ERROR_INVALID_POINTER_GUID,
];

// Import/Export Queue
export const SORT_FIELD_NAME = 'title';
export const SORT_FIELD_UPLOADED_BY = 'creator';
export const SORT_FIELD_EXPORTED_BY = 'creator';
export const SORT_FIELD_DATE_ADDED = 'created_on';
export const SORT_FIELD_DATE_EXPORTED = 'created_on';
export const SORT_FIELD_STATUS = 'status';
export const SORT_FIELD_IMPORT_STATUS = 'import_status';
export const SORT_FIELD_EXPORT_TYPE = 'export_type';

export const QUEUE_ITEM_STATUS_COMPLETE = 'complete';
export const QUEUE_ITEM_STATUS_QUEUED = 'queued';
export const QUEUE_ITEM_STATUS_ERROR = 'error';
export const QUEUE_ITEM_STATUS_PROCESSING = 'processing';
export const QUEUE_ITEM_STATUS_EXPIRED = 'expired';

export const QUEUE_ITEM_UPDATE_INTERVAL = 15000;

export const EXPORT_TYPE_WORD = 'word';
export const EXPORT_TYPE_BULK_GENERATE = 'bulk_generate';
export const EXPORT_QUEUE_TYPE_MAPPING = {
  [EXPORT_TYPE_WORD]: '.docx',
  [EXPORT_TYPE_BULK_GENERATE]: 'Studio',
};

// Manuscript
export const MAXIMUM_SELECTABLE_MANUSCRIPTS = 50;
export const CLEAR_MANUSCRIPT = 'clearManuscript';
export const DELETE_MANUSCRIPT = 'deleteManuscript';
export const PATCH_MANUSCRIPT = 'patchManuscript';
export const POST_EXPORTS = 'postExports';
export const POST_MANUSCRIPT = 'postManuscript';
export const GET_MANUSCRIPT_PRODUCT_CONFIG = 'getManuscriptProductConfig';
export const GET_MANUSCRIPT = 'getManuscript';
export const GET_MANUSCRIPTS = 'getManuscripts';
export const GET_MANUSCRIPT_USERS = 'getManuscriptUsers';
export const UPDATE_STORE_MANUSCRIPT = 'updateStoreManuscript';
export const UPDATE_STORE_MANUSCRIPTS_FROM_SERVER = 'updateStoreManuscriptsFromServer';
export const REMOVE_BULK_GENERATE_JOB = 'removeBulkGenerateJob';
export const POLL_BULK_GENERATION = 'pollBulkGeneration';
export const GENERATE_LESSON = 'generateLesson';
export const GENERATE_PAGE = 'generatePage';
export const FETCH_DRAFT_FOR_PREVIEW = 'fetchDraftForPreview';
export const EXPORT_AS_STUDIO_RESOURCE = 'exportAsStudioResource';

export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_FILTER_BY_SEARCH_TEXT = 'setFilterBySearchText';
export const SET_FILTER_BY_ASSIGNEE_IDS = 'setFilterByAssigneeIds';
export const SET_FILTER_BY_PROJECT_IDS = 'setFilterByProjectIds';
export const SET_FILTER_BY_STATUSES = 'setFilterByStatuses';
export const SET_FILTER_BY_UNASSIGNED = 'setFilterByUnassigned';
export const SET_MANUSCRIPTS_PER_PAGE = 'setManuscriptsPerPage';
export const SET_FILTER_BY_DATE_RANGE = 'setFilterByDateRange';
export const SET_FILTER_BY_LESSON_TYPES = 'setFilterByLessonTypes';
export const SET_FILTER_BY_GRADES = 'setFilterByGrades';
export const SET_FILTER_BY_READING_LEVELS = 'setFilterByReadingLevels';
export const SET_FILTER_BY_LANGUAGES = 'setFilterByLanguages';
export const SET_SELECTED_MANUSCRIPT_IDS = 'setSelectedManuscriptIds';
export const SET_SORT_BY = 'setSortBy';
export const SET_SORT_DIRECTION = 'setSortDirection';
export const SET_INITIAL_SEARCH_PARAMS = 'setInitialSearchParams';

export const BULK_DELETE_MANUSCRIPTS = 'bulkDeleteManuscripts';
export const BULK_UPDATE_ASSIGNEE = 'bulkUpdateAssignee';
export const BULK_UPDATE_STATUS = 'bulkUpdateStatus';

export const SORT_DIRECTION_ASC = 'asc';
export const SORT_DIRECTION_DESC = 'desc';

export const UPDATE_USERS_ASSIGNED_A_COLOR = 'updateUsersAssignedAColor';
export const RESET_ALL_FILTERS = 'resetAllFilters';
export const UNASSIGN_VALUE = 'unassign';

// Project
export const GET_PROJECTS = 'getProjects';

// Product Config
export const GET_PRODUCT_CONFIG = 'getProductConfig';
export const RESET_PRODUCT_CONFIG = 'resetProductConfig';

// Users
export const GET_USERS = 'getUsers';

// Toast Messages
export const ADD_TOAST_MESSAGE = 'addToastMessage';
export const REMOVE_TOAST_MESSAGE = 'removeToastMessage';

// Product Bar Top Hat
export const SHOW_MANUSCRIPT_TOP_HAT = 'showManuscriptTopHat';
export const HIDE_MANUSCRIPT_TOP_HAT = 'hideManuscriptTopHat';

// Top Hat types. Each value names a registry entry in TOP_HAT_MESSAGES
// below. All are URL-driven via the `topHatType` query param.
// Additional `topHat*`-prefixed URL params declared in an entry's
// `urlParams` are read as interpolation values (not as triggers).
export const TOP_HAT_TYPE_BULK_ERROR_ASSIGNEE = 'bulk-error-assignee';
export const TOP_HAT_TYPE_BULK_ERROR_STATUS = 'bulk-error-status';
export const TOP_HAT_TYPE_BULK_INVALID_ASSIGNEE = 'bulk-invalid-assignee';
export const TOP_HAT_TYPE_BULK_INVALID_STATUS = 'bulk-invalid-status';
export const TOP_HAT_TYPE_BULK_GENERATION_ERRORS = 'bulk-generation-errors';

/**
 * Vocabulary injected into TopHatEntry.onCta / onDismiss callbacks.
 * Keeps registry entries as pure data; the component supplies the
 * concrete implementations.
 * @typedef {Object} TopHatHandlers
 * @property {() => void} resetFilters  Calls RESET_ALL_FILTERS on the manuscript store.
 * @property {() => void} clearQuery    Strips topHatType plus every key in the active entry's urlParams from the URL.
 */

/**
 * Per-type registry entry. Bundles everything ProductBarTopHat needs
 * to render and dispatch interactions for one TOP_HAT_TYPE_*.
 * @typedef {Object} TopHatEntry
 * @property {string[]} urlParams                 URL query keys this entry
 *                                                reads. ProductBarTopHat
 *                                                plucks these from
 *                                                $route.query and passes
 *                                                them as the `values`
 *                                                object to `message()`.
 *                                                Same keys are stripped
 *                                                from the URL by
 *                                                clearTopHatQuery.
 *                                                Prefix keys with
 *                                                `topHat` to namespace
 *                                                them against route /
 *                                                filter params (e.g.
 *                                                `topHatBulkName`,
 *                                                `topHatAssignee`).
 * @property {string[]} [resetsFilters]           List-filter keys that
 *                                                SET_INITIAL_SEARCH_PARAMS
 *                                                should reset to module
 *                                                defaults when this
 *                                                entry's topHatType is
 *                                                present in the URL.
 *                                                Filters not listed are
 *                                                preserved from the
 *                                                current store state.
 *                                                `manuscript_id` is
 *                                                NEVER auto-reset --
 *                                                it's the intentional
 *                                                URL filter. Use
 *                                                RESET_ALL_LIST_FILTERS
 *                                                for the common
 *                                                clear-everything case.
 *                                                Valid keys:
 *                                                  - 'assignee_id'
 *                                                  - 'project_id'
 *                                                  - 'progress_status_id'
 *                                                  - 'searchText'
 *                                                  - 'page'
 *                                                  - 'per_page'
 *                                                  - 'sort_field'
 *                                                  - 'sort_direction'
 *                                                Omit or pass [] to
 *                                                preserve every filter.
 * @property {(values: Record<string, string>) => string} message
 *                                                Builds the body copy.
 *                                                `values` is keyed by
 *                                                urlParams names; missing
 *                                                keys are absent from
 *                                                the object.
 * @property {string} ctaText                     Primary button label.
 * @property {boolean} dismissible                Whether the dismiss (X) button renders.
 * @property {string} [icon]                      NebulaTopHat icon id. Defaults to 'information' if omitted.
 * @property {string} [state]                     NebulaTopHat state ('warn', 'info', etc.). Defaults to 'warn' if omitted.
 * @property {(handlers: TopHatHandlers) => void} [onCta]     Primary-click handler.
 * @property {(handlers: TopHatHandlers) => void} [onDismiss] Dismiss handler.
 */

/**
 * Preset for TopHatEntry.resetsFilters that clears every list-shaping
 * filter to its module default when the entry's topHatType is set in
 * the URL. Matches the legacy bulk-generation reset behavior.
 * `manuscript_id` is intentionally excluded -- it's the URL-driven
 * filter the banner is directing the user to.
 */
export const RESET_ALL_LIST_FILTERS = Object.freeze([
  'assignee_id',
  'project_id',
  'progress_status_id',
  'searchText',
  'page',
  'per_page',
  'sort_field',
  'sort_direction',
  'date_from',
  'date_to',
  'type_id',
  'grade',
  'reading_level',
  'language',
]);

const clearFiltersAction = ({ resetFilters, clearQuery }) => {
  resetFilters();
  clearQuery();
};

const dismissClearsQuery = ({ clearQuery }) => clearQuery();

const filteredListEntry = (messageString) => ({
  urlParams: [],
  resetsFilters: RESET_ALL_LIST_FILTERS,
  message: () => messageString,
  ctaText: 'Clear Filters',
  dismissible: true,
  onCta: clearFiltersAction,
  onDismiss: dismissClearsQuery,
});

// Top Hat registry. Keys MUST match the TOP_HAT_TYPE_* constants
// above. Unknown types render no banner -- this is the safe default
// that protects against arbitrary text being injected via the URL.
//
// Stored as a Map (not a plain object) so that lookups against a
// user-controlled key cannot accidentally resolve to an inherited
// Object.prototype member (e.g. toString, hasOwnProperty).
// Map.prototype.get only returns user-set entries.
/** @type {Map<string, TopHatEntry>} */
export const TOP_HAT_MESSAGES = new Map([
  [TOP_HAT_TYPE_BULK_ERROR_ASSIGNEE, filteredListEntry('You are viewing a filtered list: manuscripts that failed to update to assignee during bulk action')],
  [TOP_HAT_TYPE_BULK_ERROR_STATUS, filteredListEntry('You are viewing a filtered list: manuscripts that failed to update to status during bulk action')],
  [TOP_HAT_TYPE_BULK_INVALID_ASSIGNEE, filteredListEntry('You are viewing a filtered list: manuscripts that failed to update to assignee during bulk action')],
  [TOP_HAT_TYPE_BULK_INVALID_STATUS, filteredListEntry('You are viewing a filtered list: manuscripts that failed to update to status during bulk action')],
  [TOP_HAT_TYPE_BULK_GENERATION_ERRORS, {
    urlParams: ['topHatBulkName'],
    resetsFilters: RESET_ALL_LIST_FILTERS,
    message: ({ topHatBulkName }) => `You are viewing a filtered list: errored manuscripts from ${String(topHatBulkName ?? '')} only`,
    ctaText: 'Clear Filters',
    dismissible: true,
    onCta: clearFiltersAction,
    onDismiss: dismissClearsQuery,
  }],
]);

// Dashboard Table Headers
export const DASHBOARD_TABLE_HEADERS = [
  {
    id: 'manuscript-item-number',
    key: 'order_number',
    label: '#',
    isSortable: true,
  },
  {
    id: 'manuscript-manuscript-name',
    key: 'title',
    label: 'Name',
    isSortable: true,
  },
  {
    id: 'manuscript-project-name',
    key: 'project',
    label: 'Project',
    isSortable: true,
  },
  {
    id: 'manuscript-assignee',
    key: 'assignee',
    label: 'Assignee',
    isSortable: false,
  },
  {
    id: 'manuscript-status',
    key: 'progress_status',
    label: 'Status',
    isSortable: true,
  },
  {
    id: 'manuscript-lesson-type',
    key: 'type',
    label: 'Lesson Type',
    isSortable: true,
  },
  {
    id: 'manuscript-grade',
    key: 'grade',
    label: 'Grade',
    isSortable: false,
  },
  {
    id: 'manuscript-updated',
    key: 'updated_on',
    label: 'Updated',
    isSortable: true,
  },
  {
    id: 'manuscript-actions',
    key: 'actions',
    label: 'Actions',
    isSortable: false,
  },
];
